import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Container,
  Row,
  Col,
  Input,
  Spinner,
} from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import Header from "components/Headers/Header";
import ReactModal from "react-modal";
import CreaAprobadorTecnico from "views/Crea/CreaAprobadorTecnico";

const AprobadorTecnico = (props) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [selectedUsuario, setSelectedUsuario] = useState("");

  useEffect(() => {
    const obtenerAreas = async () => {
      try {
        const response = await axios.get(
          "https://contratosback-dev.azurewebsites.net/api/v1/ObtenerAreas"
        );
        setAreas(response.data);
      } catch (error) {
        console.error("Error al obtener las áreas:", error);
      }
    };

    obtenerAreas();
  }, []);

  useEffect(() => {
    if (selectedArea) {
      const obtenerUsuariosPorArea = async () => {
        try {
          const response = await axios.get(
            `https://contratosback-dev.azurewebsites.net/api/v1/AprobadoresArea/${selectedArea}`
          );
          setUsuarios(response.data);
        } catch (error) {
          console.error("Error al obtener los usuarios:", error);
        }
      };
      obtenerUsuariosPorArea();
    } else {
      setUsuarios([]);
    }
  }, [selectedArea]);

  return (
    <>
      <Header />

      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0 text-center">
                APROBADORES TÉCNICOS
                <hr />
              </CardHeader>
              <CardBody>
                <center>
                  <CreaAprobadorTecnico />
                </center>
                <FormGroup>
                  <label htmlFor="areaSelect">
                    Seleccione el área encargada
                  </label>
                  <Input
                    type="select"
                    id="areaSelect"
                    value={selectedArea}
                    onChange={(e) => setSelectedArea(e.target.value)}
                  >
                    <option value="">Seleccione</option>
                    {areas.map((area) => (
                      <option key={area.id} value={area.id}>
                        {area.nombreArea}
                      </option>
                    ))}
                  </Input>
                </FormGroup>

                {usuarios.length > 0 && (
                  <FormGroup>
                    <label htmlFor="usuarioSelect">Listado de usuarios</label>
                    <Input
                      type="select"
                      id="usuarioSelect"
                      value={selectedUsuario}
                      onChange={(e) => setSelectedUsuario(e.target.value)}
                    >
                      <option value="">Seleccione</option>
                      {usuarios.map((usuario) => (
                        <option key={usuario.id} value={usuario.id} disabled>
                          {usuario.nombre}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AprobadorTecnico;
